export const DEFAULT_MAX_URLS_TO_SCRAPE = 10;

export const CREATE_SOURCE_BROWSERBASE_URL_REQUIRED_ERROR = "URL is required";
export const CREATE_SOURCE_BROWSERBASE_INVALID_URL_ERROR = "Please enter a valid URL";
export const CREATE_SOURCE_BROWSERBASE_API_KEY_REQUIRED_ERROR = "API key is required";
export const CREATE_SOURCE_BROWSERBASE_PROJECT_ID_REQUIRED_ERROR = "Project ID is required";

export const SOURCE_BROWSERBASE_CONFIGURATION_CASE = "sourceBrowserbase";
